import { LinkedinFilled } from "@ant-design/icons";
import { type FunctionComponent } from "react";

import { cn } from "@btnet/utilities-core";

import { type IBTIconProps } from "../BTIcon.types";
import { useAntIcon } from "../BTIcon.utilities";

interface IBTIconLinkedinFilledProps extends IBTIconProps {
    isOnDark?: boolean;
}
export const BTIconLinkedinFilled: FunctionComponent<IBTIconLinkedinFilledProps> = (baseProps) => {
    const { isOnDark, ...iconProps } = baseProps;
    const [props] = useAntIcon(iconProps);

    return (
        <LinkedinFilled
            {...props}
            className={cn("BTIconLinkedinFilled", props.className, { isOnDark })}
        />
    );
};
